import { MachineType } from '@internal/utils/machine/MachineType'
import React from 'react'
import { ProductCard } from '../ProductCard'
import styles from './productCardGhost.module.scss'

export const ProductCardGhost: React.FC = React.memo(() => (
  <div className={styles.ghost}>
    <ProductCard title='Placeholder' url='/en/' locale='en' />
  </div>
))

ProductCardGhost.displayName = 'ProductCardGhost'
